





































































import { mapGetters, mapActions } from 'vuex'
import TableRow from '@/components/TableRow.vue'
import TableCell from '@/components/TableCell.vue'
import OrderIdTableCell from '@/components/OrderIdTableCell.vue'
import OrderRouteTableCells from '@/components/OrderRouteTableCells.vue'
import OrderRequirementsTableCell from '@/components/OrderRequirementsTableCell.vue'
import VehicleSpecificationsForm from './VehicleSpecificationsForm.vue'
import RequiredActionsTableCell from './RequiredActionsTableCell.vue'
import { applyCustomErrorConfig, isServerError } from '@/custom-errors'
import { PROGRESS_FILTER } from '../constants'

export default {
  components: {
    TableRow,
    TableCell,
    OrderIdTableCell,
    OrderRouteTableCells,
    OrderRequirementsTableCell,
    RequiredActionsTableCell,
    VehicleSpecificationsForm
  },
  props: {
    order: { type: Object, required: true },
    multiStop: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['canUseCarrierTimesFeature', 'transportRequest']),
    detailPageUrl() {
      return `${this.$route.path}/${this.order.id}`
    },
    pickupStart() {
      return this.canUseCarrierTimesFeature
        ? this.order.carrierPickupStart
        : this.order.pickupStart
    },
    pickupEnd() {
      return this.canUseCarrierTimesFeature
        ? this.order.carrierPickupEnd
        : this.order.pickupEnd
    },
    deliveryStart() {
      return this.canUseCarrierTimesFeature
        ? this.order.carrierDeliveryStart
        : this.order.deliveryStart
    },
    deliveryEnd() {
      return this.canUseCarrierTimesFeature
        ? this.order.carrierDeliveryEnd
        : this.order.deliveryEnd
    },
    statusChipCategory() {
      switch (this.order.progress) {
        case PROGRESS_FILTER.FUTURE:
          return 'primary'
        case PROGRESS_FILTER.ONGOING:
          return 'green'
        case PROGRESS_FILTER.PAST:
          return 'secondary'
        default:
          return 'red'
      }
    }
  },
  methods: {
    ...mapActions(['loadTransportDetails']),
    async onBeforeExpanded() {
      try {
        await this.loadTransportDetails(this.order.id)
      } catch (error) {
        if (isServerError(error)) {
          this.alertModal.showErrorMessage(
            this.$t('serverError.title'),
            this.$t('serverError.msg'),
            applyCustomErrorConfig
          )
          throw error
        }
      }
    }
  }
}
